import React from 'react'

const LockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.50001 12.8333C3.17918 12.8333 2.90452 12.719 2.67605 12.4905C2.44758 12.2621 2.33334 11.9874 2.33334 11.6666V5.83325C2.33334 5.51242 2.44758 5.23777 2.67605 5.00929C2.90452 4.78082 3.17918 4.66659 3.50001 4.66659H4.08334V3.49992C4.08334 2.69297 4.36772 2.00513 4.93647 1.43638C5.50522 0.867627 6.19307 0.583252 7.00001 0.583252C7.80695 0.583252 8.4948 0.867627 9.06355 1.43638C9.6323 2.00513 9.91668 2.69297 9.91668 3.49992V4.66659H10.5C10.8208 4.66659 11.0955 4.78082 11.324 5.00929C11.5524 5.23777 11.6667 5.51242 11.6667 5.83325V11.6666C11.6667 11.9874 11.5524 12.2621 11.324 12.4905C11.0955 12.719 10.8208 12.8333 10.5 12.8333H3.50001ZM7.00001 9.91658C7.32084 9.91658 7.5955 9.80235 7.82397 9.57388C8.05244 9.3454 8.16668 9.07075 8.16668 8.74992C8.16668 8.42909 8.05244 8.15443 7.82397 7.92596C7.5955 7.69749 7.32084 7.58325 7.00001 7.58325C6.67918 7.58325 6.40452 7.69749 6.17605 7.92596C5.94758 8.15443 5.83334 8.42909 5.83334 8.74992C5.83334 9.07075 5.94758 9.3454 6.17605 9.57388C6.40452 9.80235 6.67918 9.91658 7.00001 9.91658ZM5.25001 4.66659H8.75001V3.49992C8.75001 3.01381 8.57987 2.60061 8.23959 2.26034C7.89932 1.92006 7.48612 1.74992 7.00001 1.74992C6.5139 1.74992 6.1007 1.92006 5.76043 2.26034C5.42015 2.60061 5.25001 3.01381 5.25001 3.49992V4.66659Z'
      fill='currentcolor'
    />
  </svg>
)

export default LockIcon
